module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/06063c7f363d7b136e8ba78e6b36b0e1.png";